import React from "react";
import { Col, FormGroup, Input, Row } from "reactstrap";
import { LocalForm, Control } from "react-redux-form";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import Select from "react-select";

export const TableSearch = ({
  onChange,
  t,
  value,
  debounce = 1000,
  tReady,
  i18nOptions,
  defaultNS,
  reportNS,
  className,
  label,
  ...props
}) =>  {

const options = [
    { label: t("January"), value: 1 },
    { label: t("February"), value: 2 },
    { label: t("March"), value: 3 },
    { label: t("April"), value: 4 },
    { label: t("May"), value: 5 },
    { label: t("June"), value: 6 },
    { label: t("July"), value: 7 },
    { label: t("August"), value: 8 },
    { label: t("September"), value: 9 },
    { label: t("October"), value: 10 },
    { label: t("November"), value: 11 },
    { label: t("December"), value: 12 },
  ];
      
return (

  <FormGroup {...props} className={classNames("table-search", className)}>
    <LocalForm component="div" onChange={({ search }) => onChange(search)}>
      <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', padding: '5px' }}>
        <FormGroup style={{ flex: 3 }}>
          <Control.text
            model=".search"
            debounce={debounce}
            component={Input}
            placeholder={label || t("search", "Search...")}
          />
        </FormGroup>
        <FormGroup style={{ flex: 1 }} >
          <Control.text
            style={{backgroundColor:'#F4F7FE'}}
            model=".search"
            debounce={debounce}
            component={Select}
            options={options}
            placeholder={t("Select Month...")}
            simpleValue
          />
        </FormGroup>
      </div>
    </LocalForm>
  </FormGroup>
)}

export const enhance = withTranslation();

export default enhance(TableSearch);
